import { Alert, AlertColor, AlertTitle, Box, Button, Snackbar, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import { useFormik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { observer } from 'mobx-react';
import LoadingButton from '@mui/lab/LoadingButton';
import { UserModel } from '../../domains/models/UserModel';
import { useRootStore } from 'store/StoreContextProvider';
import { useNavigate } from 'react-router-dom';

import { loginRequest } from '../../authConfig';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import ms_button from '../../assets/image/ms_button.svg';
import pas_logo from '../../assets/image/pas_logo.svg';

export interface LoginPageFormData {
  username: string;
  password: string;
}

const LoginPage = () => {
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState({
    open: false,
    severity: 'success',
    message: '',
    title: '',
  });
  const { loginStore } = useRootStore();
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isSSOButtonClicked, setSSOButtonClicked] = React.useState(false);

  const signin = async (username: string, password: string) => {
    try {
      const response = await loginStore.onLogin(username, password);
      if (response.user) {
        const user: UserModel = {
          ...response.user,
        };
        loginStore.setCurrentUser(user, response.accessToken as string, response.refreshToken as string);
        await loginStore.fetchConfigSettings();

        //await loginStore.defaultDownPeerSetting(response.user);

        window.location.href = '/';
      }
    } catch (error) {
      console.log(error);
      const response = error as {
        code: number;
      };
      if (response.code !== 200) {
        setAlert({
          open: true,
          severity: 'error',
          title: '로그인에러',
          message: '사용자 아이디와 바밀번호를 확인하세요.',
        });
      }
    }
  };

  // const classes = useStyles();
  /************************************************************************
   * Form
   ************************************************************************/
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      username: yup.string().required(' 사용자아이디를 입력하세요.'),
      password: yup.string().required(' 비밀번호를 입력하세요.'),
    }),
    onSubmit: (values: LoginPageFormData) => {
      console.log('login', values);
      signin(values.username, values.password);
    },
  });

  const onHandleSSO = async () => {
    // Start the authorization code flow by redirecting the
    // browser to Microsoft identity platforms authorization URL
    setSSOButtonClicked(true);
    instance.loginRedirect(loginRequest);
  };

  /************************************************************************
   * Render
   ************************************************************************/

  return (
    <Box sx={{ width: '100%' }} display='flex' justifyContent='center' alignItems='center' minHeight='70vh'>
      <Grid container xs={8} md={8}>
        <Grid xs={12} md={6} mdOffset={3}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container alignItems='center'>
              <img src={pas_logo} alt='logo' width={24} height={24} style={{ marginRight: 5 }} />

              <Typography fontSize={24} fontWeight={'bold'} color={'#333333'}>
                PAS
              </Typography>
            </Grid>

            {process.env.NODE_ENV !== 'production' && (
              <TextField
                id='username'
                name='username'
                label='사용자아이디'
                margin='normal'
                type='string'
                value={formik.values.username}
                error={formik.touched.username && Boolean(formik.errors.username)}
                helperText={formik.touched.username && formik.errors.username}
                fullWidth
                onChange={formik.handleChange}
              />
            )}
            {process.env.NODE_ENV !== 'production' && <TextField id='password' name='password' label='비밀번호' margin='normal' type='password' value={formik.values.password} fullWidth onChange={formik.handleChange} />}
            {process.env.NODE_ENV !== 'production' && (
              <LoadingButton type='submit' color='primary' variant='contained' size='large' loading={loading} fullWidth={true}>
                로그인
              </LoadingButton>
            )}
          </form>
        </Grid>
        <Grid xs={12} md={6} mdOffset={3} style={{ marginTop: '10px' }}>
          <LoadingButton type='button' style={{ backgroundColor: 'white' }} variant='contained' size='large' loading={loading} onClick={onHandleSSO} fullWidth={true}>
            <img src={ms_button} alt='menuIcon' />
          </LoadingButton>
        </Grid>
        <Grid xs={12} md={6} mdOffset={3} style={{ marginTop: '10px', color: 'gray', fontSize: 10, textAlign: 'right' }}>
          Ver:{process.env.REACT_APP_VERSION}
        </Grid>
      </Grid>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={alert.open} autoHideDuration={3000} onClose={(e) => setAlert({ open: false, severity: 'success', message: '', title: '' })}>
        <Alert variant='filled' severity={alert.severity as AlertColor} sx={{ width: '100%' }}>
          <AlertTitle>{alert.title}</AlertTitle>
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default observer(LoginPage);
